/**
 * Service image paths - served from /public/images/
 * To update an image: replace the file in public/images/ with the same name
 */
const serviceImages = {
  wde:            "/images/wde.webp",
  mobile:         "/images/mobile.webp",
  cloud:          "/images/cloud.webp",
  uiux:           "/images/uiux.webp",
  seo:            "/images/seo.webp",
  consulting:     "/images/consulting.webp",
  digitalProfile: "/images/digital_profile.webp",
};

export default serviceImages;
